var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwitchButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 11C0.5 16.775 5.225 21.5 11 21.5C16.775 21.5 21.5 16.775 21.5 11C21.5 5.225 16.775 0.499999 11 0.5C5.225 0.5 0.499999 5.225 0.5 11ZM10.625 11.75L8.375 14L15.5 14L15.5 15.5L8.45 15.5L10.7 17.75L8.75 17.75L5.75 14.75L8.75 11.75L10.625 11.75ZM13.25 4.25L16.25 7.25L13.25 10.25L11.375 10.25L13.625 8L6.5 8L6.5 6.5L13.55 6.5L11.3 4.25L13.25 4.25Z",
    fill: "#1E9162"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchButton);
export default __webpack_public_path__ + "static/media/switch-button.762f818e43c6be278b13d2f5672004a0.svg";
export { ForwardRef as ReactComponent };